import { render } from "./SessionAttendTable.vue?vue&type=template&id=29ba7d7a&scoped=true"
import script from "./SessionAttendTable.vue?vue&type=script&lang=ts"
export * from "./SessionAttendTable.vue?vue&type=script&lang=ts"

import "./SessionAttendTable.vue?vue&type=style&index=0&id=29ba7d7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29ba7d7a"

export default script